import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import moment from 'moment';
import { of, Subscription, switchMap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';

import { SnackbarSaveDraftGuaranteeComponent } from '../../utils/snackbar-save-draft-guarantee.component';
import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { StepStatus, StepperComponent } from '../../../../shared/components/stepper/stepper.component';
import { User } from '../../../../shared/models/user';
import { ErrorService } from '../../../../shared/services/error.service';
import { LocationService } from '../../../../shared/services/location.service';
import { TranslationService } from '../../../../shared/services/translation.service';
import { UserService } from '../../../../shared/services/user.service';
import { Guarantee } from '../../../models/guarantee';
import { GuaranteeRequestService } from '../../../services/guarantee-request.service';
import { GuaranteeStatus } from '../../../models/guarantee-constants';
import { BocClient } from '../../../../shared/models/boc-client-transac';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';
import { InputNumberDirective } from '../../../../shared/directives/input-number.directive';
import { PageHeaderComponent } from '../../../../shared/components/page-header/page-header.component';
import {
	FeedbackErrorComponent
} from '../../../../shared/components/feedback-error/feedback-error.component';

interface ErrorObject {

	soldTo: boolean;
	name: boolean;

}
@Component({
	selector: 'copo-project-characteristics-building',
	templateUrl: './project-characteristics-building.component.html',
	styleUrl: './project-characteristics-building.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		CdkScrollable,
		PageHeaderComponent,

		MatButtonModule,
		TranslateModule,
		MatIconModule,
		FormsModule,
		StepperComponent,

		MatFormFieldModule,

		MatInputModule,
		ReactiveFormsModule,

		MatSelectModule,
		NgFor,

		MatOptionModule,

		MatCheckboxModule,
		InputNumberDirective,

		MatRadioModule,
		LoadingSpinnerComponent,
		FeedbackErrorComponent,
	]
})
export class ProjectCharacteristicsBuildingComponent implements OnInit, OnDestroy {
	@ViewChild('soldToDiv', { read: ElementRef }) soldToDiv!: ElementRef<HTMLElement>;
	@ViewChild('nameDiv', { read: ElementRef }) nameDiv!: ElementRef<HTMLElement>;

	@Input() guaranteeResponse!: Guarantee;

	submitting = false;
	isLoading = true;
	soldTos: BocClient[] | undefined;
	guarantee!: Guarantee;
	user: User;

	readonly steps;

	onErrorMandatory = {

		soldTo: false,
		name: false,

	};

	selectedOption = new FormControl('newBuildingCompleteConstruction');
	powerFormControl!: FormControl<string>;
	magnelisTonnageFormControl!: FormControl<string>;

	soldToFormControl!: FormControl<string>;

	newSolarPlantFormControl!: FormControl<boolean>;
	existingSolarPlantFormControl!: FormControl<boolean>;
	retrofittingSolarPlantFormControl!: FormControl<boolean>;
	projectNameFormControl!: FormControl<string>;
	newBuildingCompleteConstructionFormControl!: FormControl<boolean>;
	extensionExistingBuildingFormControl!: FormControl<boolean>;
	retrofittingRepairExistingBuildingFormControl!: FormControl<boolean>;
	roofingFormControl!: FormControl<boolean>;
	wallFacadeFormControl!: FormControl<boolean>;
	compositeFloorFormControl!: FormControl<boolean>;
	perforatedSheetFormControl!: FormControl<boolean>;
	perSheetRichFormControl!: FormControl<string>;
	coldFormedStrutFormControl!: FormControl<boolean>;
	rainWaterSystemsGuttersFormControl!: FormControl<boolean>;
	residentialUseFormControl!: FormControl<boolean>;
	industrialFormControl!: FormControl<boolean>;
	agriculturalFormControl!: FormControl<boolean>;
	otherADBFormControl!: FormControl<boolean>;
	otherADBSpecifyFormControl!: FormControl<string>;
	acitivityInsideBuildingFormControl!: FormControl<string>;
	presenceofChemicalFormControl!: FormControl<string>;
	natureContentFormControl!: FormControl<string>;
	presenceofFermentationFormControl!: FormControl<string>;
	natureContent2FormControl!: FormControl<string>;
	cattleFormControl!: FormControl<boolean>;
	pigsFormControl!: FormControl<boolean>;
	polutryFormControl!: FormControl<boolean>;
	otherAnimalsFormControl!: FormControl<boolean>;
	animalsInsideBuildingFormControl!: FormControl<string>;
	densityofAnimalsFormControl!: FormControl<string>;
	gasvaporNatureContentFormControl!: FormControl<string>;
	heatingTypeFormControl!: FormControl<string>;
	qiaExtractorFormControl!: FormControl<boolean>;
	qiaChimneyFormControl!: FormControl<boolean>;
	qiaNaturalventilationFormControl!: FormControl<boolean>;
	qiaForcedventilationFormControl!: FormControl<boolean>;
	otherEquipmentFormControl!: FormControl<boolean>;
	specifyOtherEquipmentFormControl!: FormControl<string>;
	humiditySpecFormControl!: FormControl<string>;
	qiacondriskbuildingFormControl!: FormControl<string>;
	manureManagementGrantingsFormControl!: FormControl<boolean>;
	manureManagementWOGrantingsFormControl!: FormControl<boolean>;
	activityBuildingFormControl!: FormControl<boolean>;
	animalsBuildingFormControl!: FormControl<boolean>;
	manureManagementFormControl!: FormControl<boolean>;
	gasVapourFormControl!: FormControl<string>;
	buildingHeatedFormControl!: FormControl<string>;
	private soldToSub!: Subscription;

	constructor(
		private readonly locationService: LocationService,
		private readonly translationService: TranslationService,
		private readonly userService: UserService,

		private readonly snackBar: MatSnackBar,
		private readonly router: Router,
		private readonly guaranteeService: GuaranteeRequestService,

		private readonly errorService: ErrorService,
	) {
		this.steps = [
			{
				label: this.translationService.getTR('guarantee.project.characteristics'),
				status: StepStatus.CURRENT,
			},
			{
				label: this.translationService.getTR('guarantee.project.environment'),
				status: StepStatus.DISABLED,
			},
			{
				label: this.translationService.getTR('guarantee.type'),
				status: StepStatus.DISABLED,
			},
			{
				label: this.translationService.getTR('guarantee.summary'),
				status: StepStatus.DISABLED,
			}
		];
		this.user = this.userService.user;
	}

	ngOnInit() {
		this.errorService.resetErrorMsg();
		this.guarantee = this.guaranteeResponse;
		this.powerFormControl = new FormControl(this.guarantee.dataOnTheProjectSize, { nonNullable: true });
		this.magnelisTonnageFormControl = new FormControl(this.guarantee.magnelisTonnage, { nonNullable: true });

		this.newSolarPlantFormControl = new FormControl(
			this.guarantee.newSolarplantCompleteConstruction,
			{ nonNullable: true }
		);
		this.existingSolarPlantFormControl = new FormControl(
			this.guarantee.extensionExistingSolarplant,
			{ nonNullable: true }
		);
		this.retrofittingSolarPlantFormControl = new FormControl(this.guarantee.retrofitting, { nonNullable: true });
		this.newBuildingCompleteConstructionFormControl = new FormControl(
			this.guarantee.newBuildingCompleteConstruction,
			{ nonNullable: true }
		);
		this.extensionExistingBuildingFormControl = new FormControl(
			this.guarantee.extensionExistingBuilding,
			{ nonNullable: true }
		);
		this.retrofittingRepairExistingBuildingFormControl = new FormControl(
			this.guarantee.retrofittingRepairExistingBuilding,
			{ nonNullable: true }
		);
		if (!this.guarantee.extensionExistingBuilding && !this.guarantee.retrofittingRepairExistingBuilding) {
			this.newBuildingCompleteConstructionFormControl.setValue(true);
			this.guarantee.newBuildingCompleteConstruction = true;
		}
		if (this.guarantee.extensionExistingBuilding) {
			this.selectedOption.setValue('extensionExistingBuilding');
			this.extensionExistingBuildingFormControl.setValue(true);
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.retrofittingRepairExistingBuilding = false;
		} else if (this.guarantee.retrofittingRepairExistingBuilding) {
			this.selectedOption.setValue('retrofittingRepairExistingBuilding');
			this.retrofittingRepairExistingBuildingFormControl.setValue(true);
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.extensionExistingBuilding = false;
		} else {
			this.selectedOption.setValue('newBuildingCompleteConstruction');
			this.newBuildingCompleteConstructionFormControl.setValue(true);
			this.guarantee.retrofittingRepairExistingBuilding = false;
			this.guarantee.extensionExistingBuilding = false;
		}
		this.roofingFormControl = new FormControl(this.guarantee.roofing, { nonNullable: true });
		this.wallFacadeFormControl = new FormControl(this.guarantee.wallFacade, { nonNullable: true });
		this.compositeFloorFormControl = new FormControl(this.guarantee.compositeFloor, { nonNullable: true });
		this.perforatedSheetFormControl = new FormControl(this.guarantee.perforatedroofSheet, { nonNullable: true });
		this.perSheetRichFormControl = new FormControl(this.guarantee.perSheetRich, { nonNullable: true });
		this.coldFormedStrutFormControl = new FormControl(this.guarantee.coldFormedStrut, { nonNullable: true });
		this.rainWaterSystemsGuttersFormControl = new FormControl(
			this.guarantee.rainWaterSystemsGutters,
			{ nonNullable: true }
		);
		this.residentialUseFormControl = new FormControl(this.guarantee.residentialUse, { nonNullable: true });
		this.industrialFormControl = new FormControl(this.guarantee.industrial, { nonNullable: true });
		this.agriculturalFormControl = new FormControl(this.guarantee.agricultural, { nonNullable: true });
		this.otherADBFormControl = new FormControl(this.guarantee.otherADB, { nonNullable: true });
		this.otherADBSpecifyFormControl = new FormControl(this.guarantee.otherADBSpecify, { nonNullable: true });
		this.acitivityInsideBuildingFormControl = new FormControl(
			this.guarantee.acitivityInsideBuilding,
			{ nonNullable: true }
		);
		this.presenceofChemicalFormControl = new FormControl(this.guarantee.presenceofChemical, { nonNullable: true });
		this.natureContentFormControl = new FormControl(this.guarantee.natureContent, { nonNullable: true });
		this.presenceofFermentationFormControl = new FormControl(
			this.guarantee.presenceofFermentation,
			{ nonNullable: true }
		);
		this.natureContent2FormControl = new FormControl(this.guarantee.natureContent2, { nonNullable: true });
		this.cattleFormControl = new FormControl(this.guarantee.cattle, { nonNullable: true });
		this.pigsFormControl = new FormControl(this.guarantee.pigs, { nonNullable: true });
		this.polutryFormControl = new FormControl(this.guarantee.polutry, { nonNullable: true });
		this.otherAnimalsFormControl = new FormControl(this.guarantee.otherAnimals, { nonNullable: true });
		this.animalsInsideBuildingFormControl = new FormControl(
			this.guarantee.animalsInsideBuilding,
			{ nonNullable: true }
		);
		this.densityofAnimalsFormControl = new FormControl(this.guarantee.densityofAnimals, { nonNullable: true });
		this.gasvaporNatureContentFormControl = new FormControl(
			this.guarantee.gasvaporNatureContent,
			{ nonNullable: true }
		);
		this.heatingTypeFormControl = new FormControl(this.guarantee.heatingType, { nonNullable: true });
		this.qiaExtractorFormControl = new FormControl(this.guarantee.qiaExtractor, { nonNullable: true });
		this.qiaChimneyFormControl = new FormControl(this.guarantee.qiaChimney, { nonNullable: true });
		this.qiaNaturalventilationFormControl = new FormControl(
			this.guarantee.qiaNaturalventilation,
			{ nonNullable: true }
		);
		this.qiaForcedventilationFormControl = new FormControl(
			this.guarantee.qiaForcedventilation,
			{ nonNullable: true }
		);
		this.otherEquipmentFormControl = new FormControl(this.guarantee.otherEquipment, { nonNullable: true });
		this.specifyOtherEquipmentFormControl = new FormControl(
			this.guarantee.specifyOtherEquipment,
			{ nonNullable: true }
		);
		this.qiacondriskbuildingFormControl = new FormControl(
			this.guarantee.qiacondriskbuilding,
			{ nonNullable: true }
		);
		this.humiditySpecFormControl = new FormControl(this.guarantee.humiditySpec, { nonNullable: true });
		this.manureManagementGrantingsFormControl = new FormControl(
			this.guarantee.manureManagementGrantings,
			{ nonNullable: true }
		);

		this.manureManagementWOGrantingsFormControl = new FormControl(
			this.guarantee.manureManagementWOGrantings,
			{ nonNullable: true }
		);
		this.activityBuildingFormControl = new FormControl(this.guarantee.activityBuilding, { nonNullable: true });
		this.animalsBuildingFormControl = new FormControl(this.guarantee.animalsBuilding, { nonNullable: true });
		this.manureManagementFormControl = new FormControl(
			this.guarantee.manureManagementBuilding,
			{ nonNullable: true }
		);
		this.gasVapourFormControl = new FormControl(this.guarantee.gasVapour, { nonNullable: true });
		this.buildingHeatedFormControl = new FormControl(this.guarantee.buildingHeated, { nonNullable: true });
		this.soldToFormControl = new FormControl(
			this.guarantee.soldTo,
			{ validators: ctrl => this.onErrorMandatory.soldTo ? Validators.required(ctrl) : null, nonNullable: true }
		);
		this.projectNameFormControl = new FormControl(
			this.guarantee.name,
			{ validators: ctrl => this.onErrorMandatory.name ? Validators.required(ctrl) : null, nonNullable: true }
		);
		this.soldToSub = this.userService.getSoldTosTransac('PGNTE')
			.pipe(

				switchMap(businessIds => {
					if (businessIds.length === 0) {
						return of(undefined);
					}

					return this.userService.getBocs(
						['name', 'businessId'],
						businessIds.map(x => `businessId:${ x }`).join(' OR ')
					);
				})
			).subscribe({
				next: soldToList => {
					this.soldTos = soldToList?.results;
					if (this.soldTos && this.soldTos.length !== 0 && !this.guarantee.soldTo) {
						this.guarantee.soldTo = this.soldTos[0].businessId;
						this.soldToFormControl.setValue(this.guarantee.soldTo);
					}
				},
				complete: () => {
					this.isLoading = false;
				}

			});
	}

	ngOnDestroy() {
		this.soldToSub.unsubscribe();
	}

	goBack() {
		if (this.guarantee.id !== undefined) {
			this.locationService.go(-1);
		} else {
			this.locationService.go(-1, '../guarantee-requests/new/guarantee-type-selector');
		}
	}

	onErrorForm(elem: ElementRef, onError: keyof ErrorObject, event: Event) {
		(<HTMLElement> elem.nativeElement).scrollIntoView();
		this.onErrorMandatory[onError] = true;
		event.preventDefault();
	}

	isSoldToValid(event: Event) {
		if (this.guarantee.soldTo === '') {
			this.onErrorForm(this.soldToDiv, 'soldTo', event);
			this.soldToFormControl.markAsTouched();
			this.soldToFormControl.updateValueAndValidity();
			return false;
		}
		return true;
	}

	isNameValid(event: Event) {
		const trimmedName = this.guarantee.name.trim();
		if (trimmedName === '') {
			this.guarantee.name = '';
			this.projectNameFormControl.setValue('', { emitEvent: false });
			this.onErrorForm(this.nameDiv, 'name', event);
			this.projectNameFormControl.markAsTouched();
			this.projectNameFormControl.setErrors({ required: true });
			this.projectNameFormControl.updateValueAndValidity();
			return false;
		}
		this.guarantee.name = trimmedName;
		this.projectNameFormControl.setValue(trimmedName, { emitEvent: false });
		return true;
	}

	async isNameUnique(): Promise<boolean> {
		this.isLoading = true;
		try {
			return await this.guaranteeService.checkNameUniquenessOrFeedback(this.guarantee.name);
		} finally {
			this.isLoading = false;
		}
	}

	async goToNextStep(event: Event) {
		this.resetOnError();
		// check mandatory fields
		// we can't push if any mandatory are not filled

		if (!this.isNameValid(event) || !this.isSoldToValid(event) || await this.isNameUnique()) {
			return;
		}

		await this.router.navigate([
			this.guarantee.id !== undefined
				? `/guarantee-requests/edit/${ this.guarantee.id }/project-environment`
				: '/guarantee-requests/new/project-environment'
		], { replaceUrl: true });
	}

	async saveGuarantee(event: Event) {
		event.preventDefault();
		this.resetOnError();
		if (!this.isNameValid(event) || !this.isSoldToValid(event)) {
			return;
		}
		const now = moment().toISOString();
		const userName = `${ this.user.firstname } ${ this.user.lastname }`;
		const userId = this.user.id;
		if (this.guarantee.status !== GuaranteeStatus.DRAFT) {
			this.guarantee.requestDate = now;
		}
		this.guarantee.requesterName = userName;
		this.guarantee.requesterId = userId;

		this.submitting = true;
		try {
			await this.guaranteeService.saveGuarantee(this.guarantee);
		} catch (err: unknown) {
			console.error(err);
			this.guarantee.status = GuaranteeStatus.DRAFT;
			this.snackBar.openFromComponent(
				SnackbarSaveDraftGuaranteeComponent,
				{
					duration: 5000,
					panelClass: ['copo-claim-draft-snackbar'],
					data: true
				}
			);
			return;
		} finally {
			this.submitting = false;
		}
		if (this.guarantee.status === GuaranteeStatus.DRAFT) {
			await this.router.navigate(['/guarantee-requests/drafts'], { replaceUrl: true });
			this.snackBar.openFromComponent(
				SnackbarSaveDraftGuaranteeComponent,
				{
					duration: 5000,
					panelClass: ['copo-claim-draft-snackbar']
				}
			);
		}
	}

	resetOnError() {
		this.onErrorMandatory.soldTo = false;
		this.onErrorMandatory.name = false;
	}

	onNewSolarPlantCheckboxChange(checked: boolean) {
		this.guarantee.newSolarplantCompleteConstruction = checked;
	}

	onExistingSolarPlantCheckboxChange(checked: boolean) {
		this.guarantee.extensionExistingSolarplant = checked;
	}

	onRetrofittingSolarPlantCheckboxChange(checked: boolean) {
		this.guarantee.retrofitting = checked;
	}

	newBuildingCompleteConstructionChanged(checked: boolean) {
		this.guarantee.newBuildingCompleteConstruction = checked;
	}

	extensionExistingBuildingChanged(checked: boolean) {
		this.guarantee.extensionExistingBuilding = checked;
	}

	retrofittingRepairExistingBuildingChanged(checked: boolean) {
		this.guarantee.retrofittingRepairExistingBuilding = checked;
	}

	radioSelectionChanged(selectedValue: string) {
		if (selectedValue === 'extensionExistingBuilding') {
			this.guarantee.extensionExistingBuilding = true;
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.retrofittingRepairExistingBuilding = false;
			this.extensionExistingBuildingFormControl.setValue(true);
		} else if (selectedValue === 'retrofittingRepairExistingBuilding') {
			this.guarantee.retrofittingRepairExistingBuilding = true;
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.extensionExistingBuilding = false;
			this.retrofittingRepairExistingBuildingFormControl.setValue(true);
		} else {
			this.guarantee.newBuildingCompleteConstruction = true;
			this.guarantee.retrofittingRepairExistingBuilding = false;
			this.guarantee.extensionExistingBuilding = false;
			this.newBuildingCompleteConstructionFormControl.setValue(true);
		}
	}

	roofingChanged(checked: boolean) {
		this.guarantee.roofing = checked;
	}

	activityChanged(checked: boolean) {
		if (!checked) {
			this.acitivityInsideBuildingFormControl.reset('');
			this.guarantee.acitivityInsideBuilding = '';
		}
	}

	animalChanged(checked: boolean) {
		if (!checked) {
			this.cattleFormControl.reset(false);
			this.pigsFormControl.reset(false);
			this.otherAnimalsFormControl.reset(false);
			this.polutryFormControl.reset(false);
			this.animalsInsideBuildingFormControl.reset('');
			this.densityofAnimalsFormControl.reset('');
			this.guarantee.cattle = false;
			this.guarantee.pigs = false;
			this.guarantee.polutry = false;
			this.guarantee.otherAnimals = false;
			this.guarantee.animalsInsideBuilding = '';
			this.guarantee.densityofAnimals = '';
		}
	}

	manureManagementChanged(checked: boolean) {
		if (!checked) {
			this.manureManagementGrantingsFormControl.reset(false);
			this.manureManagementWOGrantingsFormControl.reset(false);
			this.guarantee.manureManagementGrantings = false;
			this.guarantee.manureManagementWOGrantings = false;
		}
	}

	wallFacadeChanged(checked: boolean) {
		this.guarantee.wallFacade = checked;
	}

	compositeFloorChanged(checked: boolean) {
		this.guarantee.compositeFloor = checked;
	}

	perforatedSheetChanged(checked: boolean) {
		this.guarantee.perforatedroofSheet = checked;
		if (!checked) {
			this.perSheetRichFormControl.reset('');
			this.guarantee.perSheetRich = '';
		}
	}

	coldFormedStrutChanged(checked: boolean) {
		this.guarantee.coldFormedStrut = checked;
	}

	rainWaterSystemsGuttersChanged(checked: boolean) {
		this.guarantee.rainWaterSystemsGutters = checked;
	}

	residentialUseChanged(checked: boolean) {
		this.guarantee.residentialUse = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	industrialChanged(checked: boolean) {
		this.guarantee.industrial = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	agriculturalChanged(checked: boolean) {
		this.guarantee.agricultural = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	otherADBChanged(checked: boolean) {
		this.guarantee.otherADB = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	qiaExtractorChanged(checked: boolean) {
		this.guarantee.qiaExtractor = checked;
	}

	qiaChimneyChanged(checked: boolean) {
		this.guarantee.qiaChimney = checked;
	}

	qiaNaturalventilationChanged(checked: boolean) {
		this.guarantee.qiaNaturalventilation = checked;
	}

	qiaForcedventilationChanged(checked: boolean) {
		this.guarantee.qiaForcedventilation = checked;
	}

	otherEquipmentChanged(checked: boolean) {
		this.guarantee.otherEquipment = checked;
		if (!checked) {
			this.specifyOtherEquipmentFormControl.reset('');
			this.guarantee.specifyOtherEquipment = '';
		}
	}

	cattleChanged(checked: boolean) {
		this.guarantee.cattle = checked;
	}

	manureManagementGrantingsChanged(checked: boolean) {
		this.guarantee.manureManagementGrantings = checked;
	}

	manureManagementWOGrantingsChanged(checked: boolean) {
		this.guarantee.manureManagementWOGrantings = checked;
	}

	pigsChanged(checked: boolean) {
		this.guarantee.pigs = checked;
	}

	polutryChanged(checked: boolean) {
		this.guarantee.polutry = checked;
	}

	otherAnimalsChanged(checked: boolean) {
		this.guarantee.otherAnimals = checked;
		if (!checked) {
			this.animalsInsideBuildingFormControl.reset('');
			this.guarantee.animalsInsideBuilding = '';
		}
	}

	presenceofChemicalChanged(event: MatRadioChange) {
		this.guarantee.presenceofChemical = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === '') {
			this.natureContentFormControl.reset('');
			this.guarantee.natureContent = '';
		}
	}

	qiacondriskbuildingChanged(event: MatRadioChange) {
		this.guarantee.qiacondriskbuilding = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === '') {
			this.humiditySpecFormControl.reset('');
			this.guarantee.humiditySpec = '';
		}
	}

	gasVapourChanged(event: MatRadioChange) {
		this.guarantee.gasVapour = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === '') {
			this.gasvaporNatureContentFormControl.reset('');
			this.guarantee.gasvaporNatureContent = '';
		}
	}

	buildingHeatedChanged(event: MatRadioChange) {
		this.guarantee.buildingHeated = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === '') {
			this.heatingTypeFormControl.reset('');
			this.guarantee.heatingType = '';
		}
	}

	animalsInsideBuildingChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.animalsInsideBuilding = target.value;
	}

	humiditySpecChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.humiditySpec = target.value;
	}

	densityofAnimalsChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.densityofAnimals = target.value;
	}

	presenceofFermentationChanged(event: MatRadioChange) {
		this.guarantee.presenceofFermentation = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === '') {
			this.natureContent2FormControl.reset('');
			this.guarantee.natureContent2 = '';
		}
	}

	natureContentChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.natureContent = target.value;
	}

	natureContent2Changed(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.natureContent2 = target.value;
	}

	perSheetRichChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.perSheetRich = target.value;
	}

	otherADBSpecifyChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.otherADBSpecify = target.value;
	}

	heatingTypeChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.heatingType = target.value;
	}

	specifyOtherEquipmentChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.specifyOtherEquipment = target.value;
	}

	acitivityInsideBuildingChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.acitivityInsideBuilding = target.value;
	}

	magnelisTonnageNameChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.magnelisTonnage = target.value;
	}

	gasvaporNatureContentChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.gasvaporNatureContent = target.value;
	}

	powerNameChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.dataOnTheProjectSize = target.value;
	}

	soldToChanged(event: MatSelectChange) {
		this.guarantee.soldTo = <string> event.value;
		this.errorService.resetErrorMsg();
	}

	projectNameChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.name = target.value.trim();
		this.projectNameFormControl.setValue(this.guarantee.name, { emitEvent: false });
		this.errorService.resetErrorMsg();
	}
}
